module.exports = __webpack_public_path__ + "static/media/Devon1.bbe176e3.jpg";